export default function useDesignLevelComposable(props, emit)
{
    function select(val)
    {
        if(val === props.modelValue)
        {
            return;
        }

        // @todo
        // ...

        emit('update:modelValue', val);
    }

    return {
        select,
    };
};
